<template lang="pug">
.v-detail-aside-card.detail-aside-card(v-if="data")
	a.detail-aside-card__link(v-if="data.link && data.link.href" :href="data.link?.href")
	.detail-aside-card__image(v-if="data.mainImage")
		img(:src="data.mainImage?.src"
			:alt="data.mainImage?.alt")
	.detail-aside-card__wrap
		.detail-aside-card__title(v-if="data.link" ) {{ data.link?.text }}
		.detail-aside-card__info
			.detail-aside-card__info-size(v-if="data.height && data.width" )
				span.detail-aside-card__info-height {{ data.height }}
				span.detail-aside-card__info-size-separator x
				span.detail-aside-card__info-widht {{ data.width }}
			.detail-aside-card__info-separator(v-if="data.type" ) |
			.detail-aside-card__info-type(v-if="data.type" ) {{ data.type }}
		img.detail-aside-card__small-img(
			v-if="data.image"
			:style="{height: `${infoImageHeight}px`, width: `${computedWidth}px`}"
			:src="data.image?.src"
			:alt="data.image?.alt")



</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {

	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null,
			infoImageHeight: 21
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	},

	computed: {
		computedWidth() {
			if(this.data.height && this.data.width) {
				const min = Math.min(this.data.height, this.data.width);
				const max = Math.max(this.data.height, this.data.width);
				return this.infoImageHeight*(max/min)
			}
			return 0;
		}
	}
}

</script>